import Cookies from "js-cookie";
import { createActionType, createAsyncAction } from "./create-actions";

export const ADD_CATALOG = createActionType("ADD_CATALOG");
export const GET_CATALOGS = createActionType("GET_CATALOGS");
export const GET_CATALOG_BY_ID = createActionType("GET_CATALOG_BY_ID");
export const EDIT_CATALOG = createActionType("EDIT_CATALOG");
export const REMOVE_CATALOG = createActionType("REMOVE_CATALOG");

export const addCatalog = (data: any) =>
  createAsyncAction(ADD_CATALOG, "/catalog/add_catalog", "post", data, {
    Authorization: `Bearer ${Cookies.get("token")}`,
  });

export const getCatalogs = () =>
  createAsyncAction(GET_CATALOGS, "/catalog/get_catalogs", "get", undefined);

export const getCatalogById = (data: any) =>
  createAsyncAction(
    GET_CATALOG_BY_ID,
    `/catalog/get_catalog_by_id/${data}`,
    "get",
    undefined
  );

export const editCatalog = (id: any, data: any) =>
  createAsyncAction(
    EDIT_CATALOG,
    `/catalog/edit_catalog_by_id/${id}`,
    "put",
    data,
    {
      Authorization: `Bearer ${Cookies.get("token")}`,
    }
  );

export const removeCatalog = (data: any) =>
  createAsyncAction(
    REMOVE_CATALOG,
    `/catalog/remove_catalog_by_id/${data}`,
    "delete",
    undefined,
    {
      Authorization: `Bearer ${Cookies.get("token")}`,
    }
  );
